export const SIZE_LABELS = {
  envelope: "Envelope: up to 0.5 kg",
  small: "Small: up to 2 kg",
  medium: "Medium: 2–5 kg",
  large: "Large: 5–15 kg",
  xl: "Extra Large: 15–30 kg",
};

export const sizeLabel = (parcel) =>
  (parcel && (parcel.size_label || SIZE_LABELS[parcel.size])) || "Size not set";
